// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/element-ui/lib/theme-chalk/collapse.css
// module id = 8mNY
// module chunks = 4